export default "__VITE_ASSET__405cfe6f__"